var base = require('settings/subscription/subscribe-stripe');

Vue.component('spark-subscribe-stripe', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/subscription/subscribe-stripe.js